import React from "react"
import ReportHolder from "../components/ReportsHolder"

function ReportPage(props) {
  const {
    match: { params },
  } = props
  const { type } = params
  return <ReportHolder num={type} type={type} />
}

export default ReportPage
